import cn from 'classnames'
import { type ChangeEvent, type ComponentProps, type ReactElement, type ReactNode, type RefObject } from 'react'
import ExclamationCircleIcon from '../icons/ExclamationCircleIcon'

interface TextInputType {
  autoComplete?: string
  autoFocus?: boolean
  error: string | null | undefined
  handleBlur: any
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  icon?: (props: ComponentProps<'svg'>) => ReactNode
  id?: string
  placeholder?: string
  reff?: RefObject<any>
  required?: boolean
  showError: boolean
  tid?: string
  type: string
  pattern?: string
  value?: string | null | undefined
  defaultValue?: string | null | undefined
}
export default function TextInput ({
  autoComplete,
  autoFocus,
  error,
  handleBlur,
  handleChange,
  icon,
  id,
  placeholder,
  reff,
  required,
  showError,
  tid,
  type,
  pattern,
  value,
  defaultValue
}: TextInputType): ReactElement {
  const Icon = icon
  return (
    <div>
      <div className="mt-1 relative rounded-md">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {/* @ts-expect-error */}
            <Icon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
        )}
        <input
          autoFocus={autoFocus}
          data-tid={tid}
          id={id}
          type={type}
          autoComplete={autoComplete}
          required={required}
          placeholder={placeholder}
          className={
            cn(
              'block appearance-none w-full py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm',
              icon ? 'pl-10' : 'pl-10 md:pl-3',
              showError
                ? 'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
                : 'px-3 border-gray-300 placeholder-gray-400 focus:ring-hh-blue-700 focus:border-hh-blue-700'
            )
          }
          ref={reff}
          onBlur={handleBlur}
          onChange={handleChange}
          pattern={pattern ?? undefined}
          value={value ?? undefined}
          defaultValue={defaultValue ?? undefined}
        />
        {showError && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon />
          </div>
        )}
      </div>
      <p
        className={cn('text-red-600 h-4', showError ? 'visible' : 'invisible')}
        style={{ fontSize: '0.65rem', marginTop: '0.06rem' }}
      >
        {error}
      </p>
    </div>
  )
}
